export default "__VITE_ASSET__3c02497b__"